import "antd/es/select/style";
import _Select from "antd/es/select";
var _excluded = ["className", "loading", "listHeight", "noBorder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import { IconDownOutlined, IconCheckSquareFilled, IconCloseOutlined } from '@osui/icons';
import { useBrandContext } from '@osui/brand-provider';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { adjustAntdProps } from './utils';
import './index.less';
var clsPrefix = 'osui-select';

function InternalSelect(props, ref) {
  var className = props.className,
      loading = props.loading,
      listHeight = props.listHeight,
      noBorder = props.noBorder,
      restProps = _objectWithoutProperties(props, _excluded);

  var _useBrandContext = useBrandContext(),
      brand = _useBrandContext.brand; // 暂时用，后面需要透传下去


  var mode = restProps.mode,
      dropdownClassName = restProps.dropdownClassName;
  var isMultiple = mode === 'multiple' || mode === 'tags';
  var adjustedProps = adjustAntdProps(restProps, [{
    targetProp: 'suffixIcon',
    shouldOverride: !loading,
    override: /*#__PURE__*/React.createElement(IconDownOutlined, null)
  }, {
    targetProp: 'dropdownClassName',
    shouldOverride: true,
    override: isMultiple ? classNames("".concat(clsPrefix, "-multiple-dropdown"), "".concat(clsPrefix, "-dropdown"), dropdownClassName) : classNames("".concat(clsPrefix, "-dropdown"), dropdownClassName),
    alwaysOverride: true
  }, {
    targetProp: 'menuItemSelectedIcon',
    shouldOverride: isMultiple,
    override: /*#__PURE__*/React.createElement(IconCheckSquareFilled, {
      className: "".concat(clsPrefix, "-check-icon")
    })
  }, {
    targetProp: 'showArrow',
    shouldOverride: isMultiple,
    override: true
  }, {
    targetProp: 'allowClear',
    shouldOverride: isMultiple,
    override: true
  }, {
    targetProp: 'removeIcon',
    shouldOverride: true,
    override: /*#__PURE__*/React.createElement(IconCloseOutlined, {
      className: "".concat(clsPrefix, "-remove-icon")
    })
  }]);
  var innerListHeight = listHeight !== null && listHeight !== void 0 ? listHeight : brand === 'icloud' ? 320 : 256;
  return /*#__PURE__*/React.createElement(_Select, _objectSpread({
    ref: ref,
    className: classNames(clsPrefix, _defineProperty({}, "".concat(clsPrefix, "-no-border"), noBorder), className),
    loading: loading,
    listHeight: innerListHeight
  }, adjustedProps));
}

var Select = /*#__PURE__*/React.forwardRef(InternalSelect);
hoistNonReactStatics(Select, _Select);
export default Select;
//# sourceMappingURL=InternalBaseSelect.js.map